'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base_object = require('clappr/src/base/base_object');

var _base_object2 = _interopRequireDefault(_base_object);

var _player_info = require('clappr/src/components/player_info');

var _player_info2 = _interopRequireDefault(_player_info);

var _hls = require('overrides/clappr/playbacks/hls');

var _hls2 = _interopRequireDefault(_hls);

var _html5_video = require('overrides/clappr/playbacks/html5_video');

var _html5_video2 = _interopRequireDefault(_html5_video);

var _flashls = require('clappr/src/playbacks/flashls');

var _flashls2 = _interopRequireDefault(_flashls);

var _html_img = require('overrides/clappr/playbacks/html_img');

var _html_img2 = _interopRequireDefault(_html_img);

var _no_op = require('clappr/src/playbacks/no_op');

var _no_op2 = _interopRequireDefault(_no_op);

var _spinner_three_bounce = require('clappr/src/plugins/spinner_three_bounce');

var _spinner_three_bounce2 = _interopRequireDefault(_spinner_three_bounce);

var _click_to_pause = require('clappr/src/plugins/click_to_pause');

var _click_to_pause2 = _interopRequireDefault(_click_to_pause);

var _play_button = require('overrides/clappr/plugins/play_button');

var _play_button2 = _interopRequireDefault(_play_button);

var _error_screen = require('overrides/clappr/plugins/error_screen');

var _error_screen2 = _interopRequireDefault(_error_screen);

var _sources = require('clappr/src/plugins/sources');

var _sources2 = _interopRequireDefault(_sources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Playback Plugins */


/* Container Plugins */


/* Core Plugins */


var Loader = function (_BaseObject) {
    _inherits(Loader, _BaseObject);

    function Loader(externalPlugins, playerId) {
        _classCallCheck(this, Loader);

        var _this = _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this));

        _this.playerId = playerId;
        _this.playbackPlugins = [_hls2.default, _html5_video2.default, _flashls2.default, _html_img2.default, _no_op2.default];
        _this.containerPlugins = [_spinner_three_bounce2.default, _click_to_pause2.default, _error_screen2.default, _play_button2.default];
        _this.corePlugins = [_sources2.default];
        if (externalPlugins) {
            _this.addExternalPlugins(externalPlugins);
        }
        return _this;
    }

    /**
     * adds all the external plugins that were passed through `options.plugins`
     * @method addExternalPlugins
     * @private
     * @param {Object} plugins the config object with all plugins
     */


    _createClass(Loader, [{
        key: 'addExternalPlugins',
        value: function addExternalPlugins(plugins) {

            if (plugins.hasOwnProperty('playback') && Array.isArray(plugins.playback)) {
                this.playbackPlugins = plugins.playback.concat(this.playbackPlugins);
            }
            if (plugins.hasOwnProperty('container') && Array.isArray(plugins.container)) {
                this.containerPlugins = plugins.container.concat(this.containerPlugins);
            }
            if (plugins.hasOwnProperty('core') && Array.isArray(plugins.core)) {
                this.corePlugins = plugins.core.concat(this.corePlugins);
            }

            _player_info2.default.getInstance(this.playerId).playbackPlugins = this.playbackPlugins;
        }
    }]);

    return Loader;
}(_base_object2.default);

exports.default = Loader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/components/loader/loader.js
// module id = 200
// module chunks = 0